module.exports = __webpack_public_path__ + "static/img/news.7843d86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/news.png
// module id = Pshm
// module chunks = 1